import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
            探索内容分类
          </h2>
          <p className="mt-3 text-foreground-500 max-w-xl mx-auto">
            八大内容板块，覆盖你感兴趣的所有领域，点击进入发现更多精彩
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-colors ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50' :
                cat.color === 'accent' ? 'bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50' :
                'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50'
              }`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 text-base mb-1.5">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}